export const helpTitle = 'Theme Settings';
export const helpContent = `
<h3>Theme Settings</h3>
<p>EasyMap 3 supports multiple visual themes to suit different working conditions and preferences.</p>

<h4>Available Themes</h4>
<ul>
  <li><strong>Dark</strong> — Dark background, light text. Reduces eye strain in low-light environments and during extended use.</li>
  <li><strong>Light</strong> — Light background, dark text. Traditional appearance for bright office environments.</li>
  <li><strong>High Contrast</strong> — Enhanced contrast for accessibility and outdoor/bright-screen viewing.</li>
</ul>

<h4>How to Switch</h4>
<p>Select a theme from the options shown. The change applies immediately across the entire application including map controls, explorers, and modals.</p>

<h4>Tips</h4>
<ul>
  <li>Dark theme is recommended for extended map viewing and nighttime operations</li>
  <li>Your theme preference is saved in your browser and persists between sessions</li>
  <li>Map basemap selection is independent of the application theme</li>
</ul>
`;
